<div class="app-error-page-dialog">
  <app-dialog-header (dialogHeaderClose)="close()"> </app-dialog-header>
  <app-error-page
    [errorPageDescription]="dialogData.description | translate"
    [errorPageTitle]="dialogData.title | translate"
    [errorPageImage]="dialogData.image"
    (errorPageGoBackHomeClick)="onGoBackHomeClick()"
  ></app-error-page>
</div>
